import { find } from 'lodash';

export const resolveDiscounts = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'discountService', discountService => {
    return discountService.findAll(page, perpage, deleted).then(list => list);
  }];
};

export const resolveDiscount = (param = 'discount') => {
  return [ '$stateParams', 'discountService', ($stateParams, discountService) => {
    return $stateParams[param] && $stateParams[param] > 0 ? discountService.findById($stateParams[param]) : {};
  }];
};

export const resolveMembershipDiscount = () => {
  return [ 'discountService', (discountService) => {
    return discountService.findMembershipDiscount();
  }];
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/resolvers/discount.resolver.js